export default __webpack_public_path__ + "static/assets/04635554fcde3556d5a4f8656d7de4ba.png";